export default {"src":"/_next/static/media/hardscaping-design.f8547432.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};